import React from 'react';

interface UsageProps {}

export const Usage: React.FunctionComponent<UsageProps> = (props) => {
    return <div className="container">Usage</div>;
};
